export default "__VITE_ASSET__Cato17mG__"